import { Injectable } from '@angular/core';
import { BaseComponent } from '@wms/components';
import { BaseVariableService, VARIABLE_CONSTANTS } from '@wms/variables';
import { PageService, ProjectService } from '@wms/services';
import { forEach } from 'lodash-es';
import { Subject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class WmsNotificationVariableService extends BaseComponent {
  projectPages: any = {};
  propertyGroupChangeSubject = new Subject();

  constructor(private variableService: BaseVariableService, private pageService: PageService) {
    super();
  }

  __getVariableDependencies() {
    this.__onPropertyChange('operation', undefined, true);
  }

  __getDataPropsForOperation(operation: any) {
    let tempPropArray: any = [],
      //for prefab project contentOptions should be limited to 'inline'
      contentOptions = this.projectService.isPrefabType() ? { 'inline': 'inline' } : { "inline": "inline", "page": "page" };
    if (operation === "toast") {
      tempPropArray = [
        { target: "content", type: "string", "widgettype": "list", useHelpTxt: true, "options": contentOptions, "value": "inline" },
        { target: 'page', type: "string", "widgettype": "list", useHelpTxt: true, 'options': this.projectPages, "hide": true },
        { target: "text", type: "string", useHelpTxt: true, "hide": true },
        { target: "duration", type: "number", "widgettype": "list", useHelpTxt: true, "options": { "0": "0", "1000": "1000", "2000": "2000", "3000": "3000", "4000": "4000", "5000": "5000", "6000": "6000", "7000": "7000", "8000": "8000", "9000": "9000", "10000": "10000", "15000": "15000" } },
        { target: "class", type: "string", "widgettype": "list", useHelpTxt: true, "options": { "Success": "Success", "Error": "Error", "Warning": "Warning", "Info": "Info" }, "hide": true },
        { target: "toasterPosition", type: "string", "widgettype": "list", useHelpTxt: true, "options": { "top left": "top left", "top center": "top center", "top right": "top right", "center left": "center left", "center center": "center center", "center right": "center right", "bottom left": "bottom left", "bottom center": "bottom center", "bottom right": "bottom right" } }
      ];

      // Add mobile-specific properties only in mobile studio
      if (this.projectService.isMobileApplicationType()) {
        tempPropArray.push(
          { target: "showclosebutton", type: "boolean", useHelpTxt: true },
          { target: "closeiconclass", type: "string", useHelpTxt: true },
          { target: "messageiconclass", type: "string", useHelpTxt: true }
        );
      }
    } else if (operation === "alert") {
      tempPropArray = [
        { target: "text", type: "string", useHelpTxt: true },
        { target: "title", type: "string", useHelpTxt: true },
        { target: "okButtonText", type: "string", useHelpTxt: true },
        { target: "alerttype", type: "string", widgettype: "list", useHelpTxt: true, "options": { "information": "information", "success": "success", "error": "error", "warning": "warning" } }
      ];
    } else if (operation === "confirm") {
      tempPropArray = [
        { target: "text", type: "string", useHelpTxt: true },
        { target: "title", type: "string", useHelpTxt: true },
        { target: "okButtonText", type: "string", useHelpTxt: true },
        { target: "cancelButtonText", type: "string", useHelpTxt: true }
      ];
    }
    return tempPropArray;
  }

  __getEventsForOperation(operation: any) {
    let events: any = [];
    switch (operation) {
      case "alert":
        events = ["onOk"];
        break;
      case "confirm":
        events = ["onOk", "onCancel", "onClose"];
        break;
      case "toast":
        events = ['onClick', 'onHide'];
        break;
    }
    return events;
  }

  /*function to handle property change for a notificationCall*/
  __onPropertyChange(propertyName: any, value?: any, initFlag?: any) {
    let selectedVariable = this.variableService.selectedVariable,
      propertyObject = this.variableService.selectedVariable.propertyObj,
      variableObject = selectedVariable.variableObject.dataBinding,
      selectedOperation = selectedVariable.variableObject['operation'],
      dataPropsBySelectedOperation,
      operationEvents,
      contentKey: any;

    if (!initFlag) {
      this.variableService.markUpdated();
    }
    /* If the 'operation' property changed, change the data properties */
    if (propertyName === 'operation') {
      /*check value sanity*/
      if (!selectedOperation || selectedOperation === '') {
        return;
      }
      //Gets the project pages list from project Service
      forEach(this.pageService.getPages(), (page: any) => {
        if (page.type === 'PARTIAL' && page.name !== 'Common') {
          this.projectPages[page.name] = page.name;
        }
      });
      dataPropsBySelectedOperation = this.__getDataPropsForOperation(selectedOperation);
      selectedVariable.variableObject.dataBinding = (initFlag && selectedVariable.variableObject.dataBinding) ? selectedVariable.variableObject.dataBinding : [];
      this.variableService.prepareBindings(dataPropsBySelectedOperation);
      this.variableService.addBindingsToProperties();

      /* get operation events and show only them */
      operationEvents = this.__getEventsForOperation(selectedOperation);
      forEach(VARIABLE_CONSTANTS.EVENTS, (event) => {
        if (propertyObject[event]) {
          propertyObject[event].hide = true;
        }
      });
      forEach(operationEvents, (event) => {
        propertyObject[event].hide = false;
      });
    }
    //get the key of the content property
    if (variableObject.length > 1) {
      forEach(variableObject, (value, key): any => {
        if (value.target === 'content') {
          contentKey = key;
          return false;
        }
      });
    }
    //display(or)hide the properties based on the operation and content value
    if (selectedOperation === 'toast' && (propertyName === 'operation' || propertyName === 'content' || propertyName === 'page' || initFlag)) {
      if (variableObject[contentKey] && variableObject[contentKey].value === 'page') {
        propertyObject.page.hide = false;
        propertyObject.text.hide = true;
        propertyObject.class.hide = true;
        this.variableService.loadPageDataParams(variableObject[1].value);
      } else {
        propertyObject.page.hide = true;
        propertyObject.text.hide = false;
        propertyObject.class.hide = false;
      }
    }
    /*executing the event change method to create callback variables.*/
    if (VARIABLE_CONSTANTS.EVENTS.indexOf(propertyName) > -1) {
      this.variableService.onEventChange(propertyName, value);
    }
    this.propertyGroupChangeSubject.next(true);
  }
}
